import { takeEvery } from 'redux-saga/effects';

import * as extrasActions from 'store/modules/extras';

import { removeExtra } from './utils';

export default function* listenRemoveExtra() {
  yield takeEvery(extrasActions.removeExtra.toString(), removeExtra);
}
